module.exports = __webpack_public_path__ + "img/Krishna_Headshot.30436a5a.png";